import { Injectable, OnInit, OnDestroy } from '@angular/core';

import { Subject, Subscription } from 'rxjs';

import { environment } from 'src/environments/environment';
import { LoggingMessageService } from './logging-message.service';
import { AuthService } from './auth.service';
import { StorageService } from './storage.service';
//import { tokenName } from '@angular/compiler';


@Injectable({
    providedIn: 'root'
})
export class WindowEventsService implements OnInit, OnDestroy {
    private $subscriptions: Subscription = new Subscription();

    private navigationChangeSource = new Subject<string>();
    public navigationChange$ = this.navigationChangeSource.asObservable();
    private user = '';

    constructor(private authService: AuthService, private logger: LoggingMessageService, private storage: StorageService) {
        this.subscribeToWindowsEvents();
    }

    ngOnInit(): void { }

    private subscribeToWindowsEvents() {
        this.user = this.authService.getTokenEmail();
        const target = this.trimWebServer(environment.Webserver);
         this.logger.debug('window-events.service', 'subscribeToWindowsEvents', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `target: ${target}`, '');
        if (window.addEventListener) { // Listen message from remote (iFrame)
             this.logger.debug('window-events.service', 'subscribeToWindowsEvents', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, 'Adding event listener', '');
            window.addEventListener('message', this.recieveMessageFromParent.bind(this, target), false);
        }
    }

    private publishNavigationChange(path: string) {
        this.navigationChangeSource.next(path);
    }

    private recieveMessageFromParent(target: string, e: any) {
        if (target && e) {
            const origin = (e.origin) ? e.origin.toString() : '';
            const isValidOrigin = origin.startsWith(target);
            if (isValidOrigin && (e.data) && !(e.data.type)) {
                // this.logger.info('window.event.service.ts', 'recieveMessageFromiFrame', `Received message. Finding Action Data: ${e.data}`, '');
                const dataString = e.data.toString();
                // this.logger.info('window.event.service.ts', 'recieveMessageFromiFrame', `Received message. Finding Action String: ${dataString}`, '');
                const action = dataString.split(':')[0];
                // this.logger.info('window.event.service.ts', 'recieveMessageFromiFrame', `Received message. Found Action: ${action}`, '');
                switch (action) {
                    case 'ndnqiwrapper-indicatornavigation':
                        const path = dataString.split(':')[1];
                        // const path = messageParts[1];
                        this.logger.info('window-events.service', 'recieveMessageFromParent', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `path: ${path}`, '');
                        this.publishNavigationChange(path);
                        break;
                    case 'ndnqiwrapper-token':
                        const token = dataString.split(':')[1];
                        this.logger.warn('window-events.service', 'recieveMessageFromParent', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `token: ${token}`, '');
                        this.storage.setToken(token);
                    break;
                    case 'ndnqiwrapper-subscription':
                        const sub = dataString.split(':')[1];
                        this.logger.info('window-events.service', 'recieveMessageFromParent', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `subscription: ${sub}`, '');
                        this.storage.setSubscription(sub);
                        break;
                    default:
                        this.logger.info('window-events.service', 'recieveMessageFromParent', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `Unknown message from parent: ${dataString}`, '');
                        break;
                }
            }
        }
    }

    private trimWebServer(webserver: string): string {
        let target = '';
        if ( (webserver) && (webserver.endsWith('/', webserver.length)) ) {
            target = webserver.substring(0 , webserver.length - 1);
        } else {
            target = webserver;
        }
        const targetparts = target.split(':');
        const stripPort = `${targetparts[0]}:${targetparts[1]}`;
        return stripPort;
    }

    unsubscribe() {
        if (this.$subscriptions) {
            this.$subscriptions.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }
}

